import type { ReactNode } from 'react'
import { Button, Card } from '@/ui/primitives'

/** Comutator simplu. Aplicatia veche folosea checkbox-uri simple; pastram forma,
 *  ca omul sa recunoasca ecranul dupa mutare. */
export function Bifa({
  eticheta, valoare, seteaza, indiciu,
}: { eticheta: string; valoare: boolean; seteaza: (v: boolean) => void; indiciu?: string }) {
  return (
    <label className="flex items-start gap-2.5 text-[14px]">
      <input type="checkbox" className="mt-0.5" checked={valoare} onChange={(e) => seteaza(e.target.checked)} />
      <span>
        {eticheta}
        {indiciu && <span className="block text-[12px] text-muted">{indiciu}</span>}
      </span>
    </label>
  )
}

/** Campul de parola pentru integrari. Serverul NU trimite niciodata parola salvata, doar
 *  o masca (`*_masked`); campul ramane gol si se trimite DOAR daca omul tasteaza una noua,
 *  ca o salvare de alt camp sa nu stearga parola existenta. */
export function CampParola({
  eticheta, valoare, seteaza, masca, id,
}: { eticheta: string; valoare: string; seteaza: (v: string) => void; masca?: string; id: string }) {
  return (
    <div>
      <label htmlFor={id} className="text-[12.5px] text-muted mb-1 block">{eticheta}</label>
      <input
        id={id} type="password" value={valoare} autoComplete="new-password"
        onChange={(e) => seteaza(e.target.value)}
        placeholder={masca ? 'salvata — lasa gol ca sa ramana' : 'nu e salvata nicio parola'}
        className="h-9 w-full px-3 rounded-[var(--radius-control)] border border-line bg-surface text-[14px] focus:border-accent outline-none"
      />
    </div>
  )
}

export function BaraStare({
  salveaza, seSalveaza, salvat, eroare, eticheta = 'Salveaza', mesajSalvat = 'Salvat', copii,
}: {
  salveaza: () => void; seSalveaza: boolean; salvat: boolean; eroare: string | null
  eticheta?: string; mesajSalvat?: string; copii?: ReactNode
}) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button variant="primary" onClick={salveaza} disabled={seSalveaza}>
        {seSalveaza ? 'Se salveaza…' : eticheta}
      </Button>
      {copii}
      {salvat && <span className="text-[13px] text-good">{mesajSalvat}</span>}
      {eroare && <span className="text-[13px] text-bad">{eroare}</span>}
    </div>
  )
}

export function Grup({ titlu, children }: { titlu: string; children: ReactNode }) {
  return (
    <Card className="p-5">
      <p className="text-[12.5px] uppercase tracking-[0.08em] text-muted mb-3">{titlu}</p>
      {children}
    </Card>
  )
}

/** Ecranele de sistem sunt rezervate administratorilor; endpointul raspunde 403, iar
 *  ecranul spune de ce, in loc sa arate o pagina goala. */
export function FaraDrept({ ce }: { ce: string }) {
  return (
    <Card className="p-8 text-center">
      <p className="text-[15px]">{ce} se vede doar cu drept de administrare</p>
      <p className="mt-1 text-[13px] text-muted">Contul tau nu are acest drept. Cere-l unui administrator.</p>
    </Card>
  )
}
